<template>
    <div class="engine">
        <div class="label">
          {{ $t('common.modals.create_external.engines.aws-lex.awsLexSettings') }}
        </div>

        <div class="engine--description">
          {{ $t('common.modals.create_external.engines.aws-lex.readMoreAbout') }}
          <a class="engine--info-url" :href="awsUrl" target="_blank">
            {{ $t('common.modals.create_external.engines.aws-lex.here') }}
          </a>
        </div>

        <or-textbox
            v-model="localAwsLexModel.settings.accessKeyId"
            :label="$t('common.modals.create_external.engines.aws-lex.accessKeyId')"
            :placeholder="$t('common.modals.create_external.engines.aws-lex.enterAccessKeyId')"
        />

        <or-textbox
            v-model="localAwsLexModel.settings.secretAccessKey"
            :label="$t('common.modals.create_external.engines.aws-lex.secretAccessKey')"
            :placeholder="$t('common.modals.create_external.engines.aws-lex.enterSecretAccessKey')"
        />

        <or-textbox
            v-model="localAwsLexModel.settings.region"
            :label="$t('common.modals.create_external.engines.aws-lex.region')"
            :placeholder="$t('common.modals.create_external.engines.aws-lex.enterRegion')"
        />

        <or-textbox
            v-model="localAwsLexModel.settings.botName"
            :label="$t('common.modals.create_external.engines.aws-lex.botName')"
            :placeholder="$t('common.modals.create_external.engines.aws-lex.enterBotsName')"
        />

        <or-textbox
            v-model="localAwsLexModel.settings.botAlias"
            :label="$t('common.modals.create_external.engines.aws-lex.botAlias')"
            :placeholder="$t('common.modals.create_external.engines.aws-lex.enterBotsAlias')"
        />
    </div>
</template>

<script>
import { AWS_LEX_DOCS_URL } from '@/config'

export const getAwsLexDefaultSettings = () => ({
  accessKeyId: '',
  secretAccessKey: '',
  region: '',
  botName: '',
  botAlias: ''
})

export default {
  props: {
    awsLexModel: {
      settings: {
        accessKeyId: String,
        secretAccessKey: String,
        region: String,
        botName: String,
        botAlias: String
      }
    },
    errors: {
      settings: {}
    }
  },

  computed: {
    localAwsLexModel: {
      get () {
        return {
          ...this.$props.awsLexModel,
          settings: {
            ...this.$props.awsLexModel.settings,
            botAlias: this.$props.awsLexModel.settings.botAlias,
            botName: this.$props.awsLexModel.settings.botName
          }
        }
      },

      set (value) {
        this.$emit('update:awsLexModel', value)
      }
    }
  },

  data () {
    return {
      awsUrl: AWS_LEX_DOCS_URL
    }
  }
}
</script>

<style scoped>

</style>
